import financeiroApi from '../financeiroApi';

const PATH = '/api/v1/backend/fiscal/codigo-tributacao-nacional';

export default {
  buscarCodigoTributacaoNacional: async (id) => {
    return financeiroApi.get(`${PATH}/${id}`);
  },

  pesquisarCodigoTributacaoNacional: async (params) => {
    return financeiroApi.get(`${PATH}/pesquisar/codigotributacaonacional`, { params });
  },
};
